var map = {
	"./FUJIFILM_Slogan.png": 277,
	"./Level3-Snipet.jpg": 886,
	"./MelGroundFloor.jpg": 887,
	"./MelGroundFloor_bkup.jpg": 888,
	"./MelbourneLevel1East.jpg": 889,
	"./MelbourneLevel1East_bkup.jpg": 890,
	"./MelbourneLevel1West.jpg": 891,
	"./MelbourneLevel1West_bkup.jpg": 892,
	"./NRLevel3RightSideMap.jpg": 893,
	"./NRLevel4LeftSideMap.jpg": 894,
	"./NRLevel4RightSideMap.jpg": 895,
	"./NRLevel5RightSideMap.jpg": 896,
	"./Perth_GFloor.jpg": 897,
	"./Perth_GFloor_old.jpg": 898,
	"./deskReservationHome.png": 279,
	"./deskReservationNav.png": 169,
	"./fujifilm_logo.png": 899,
	"./gmdHomePageImg.jpeg": 900,
	"./gmdLogo.JPG": 901,
	"./head_fxlogo.gif": 902,
	"./office_desk_logo_backup.png": 903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 885;